import React from "react";

const Dropdown3 = () => {
  return <div className="dropdown-3">Dropdown 3</div>;
};

export default Dropdown3;
